import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getListRequestLeaveStart,
  getListRequestLeaveSuccess,
  getListRequestLeaveFailed,
} from "../redux/getListRequestLeave";
import { getListRequestLeaveAPI } from "core/http/service/decleareLeave";
import moment from "moment";

function* getListRequestLeaveWork(action) {
  const { screenCode, ...payload } = action.payload;
  try {
    const res = yield call(getListRequestLeaveAPI, {
      screenCode,
      ...payload,
    });
    const formattedData = res.data.map((item, index) => ({
      ...item,
      index: index + 1,
      fromDate: moment(item?.fromDate),
      toDate: moment(item?.toDate),
    }));
    yield put({
      type: getListRequestLeaveSuccess.type,
      payload: formattedData,
    });
  } catch (error: any) {
    yield put({
      type: getListRequestLeaveFailed.type,
    });
  }
}

function* watchGetListRequestLeave() {
  yield takeLatest(getListRequestLeaveStart.type, getListRequestLeaveWork);
}

export default function* getListRequestLeaveSaga() {
  yield all([watchGetListRequestLeave()]);
}
